// Nancy — PDP Image Gallery, Variant Picker, Lightbox, Sticky Bar, Quantity
(function() {
  const mainImg = document.getElementById('pdp-main-img');
  const thumbs = Array.from(document.querySelectorAll('.pdp-gallery-thumbs button'));
  const heroEl = document.querySelector('.pdp-hero');
  const waveEl = document.querySelector('.pdp-wave-overlay');

  function swapMainImage(src, alt) {
    if (!mainImg) return;
    mainImg.style.opacity = '0';
    const newImg = new Image();
    newImg.onload = () => {
      mainImg.src = src;
      mainImg.alt = alt || '';
      mainImg.style.opacity = '1';
    };
    newImg.src = src;
  }

  function setActiveThumb(target) {
    thumbs.forEach(t => {
      t.classList.toggle('active', t === target);
      t.setAttribute('aria-selected', t === target ? 'true' : 'false');
    });
  }

  // ─── Thumbnail clicks ───
  if (mainImg && thumbs.length) {
    thumbs.forEach(btn => {
      btn.addEventListener('click', () => {
        const img = btn.querySelector('img');
        if (!img) return;
        const src = img.getAttribute('data-full') || img.src;
        swapMainImage(src, img.alt || '');
        setActiveThumb(btn);
      });
    });

    // Keyboard nav (only when a thumb is focused)
    document.addEventListener('keydown', (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      const active = document.querySelector('.pdp-gallery-thumbs button.active');
      if (!active) return;
      const idx = thumbs.indexOf(active);
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        const next = thumbs[(idx + 1) % thumbs.length];
        next.click();
        next.focus();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        const prev = thumbs[(idx - 1 + thumbs.length) % thumbs.length];
        prev.click();
        prev.focus();
      }
    });
  }

  // ─── Variant wave background transition ───
  function triggerWave(color) {
    if (!waveEl || !color) return;
    waveEl.style.backgroundColor = color;
    waveEl.classList.remove('pdp-wave-overlay--animating');
    // Force reflow to restart the animation
    void waveEl.offsetWidth;
    waveEl.classList.add('pdp-wave-overlay--animating');
  }

  // ─── Variant Picker (color / size) ───
  const options = document.querySelectorAll('.pdp-color-option, .pdp-size-option');
  const colorName = document.getElementById('color-name');
  const variantInput = document.getElementById('variant-id');
  const cartBtn = document.getElementById('add-to-cart-btn');
  const stickyPriceEl = document.getElementById('pdp-sticky-price');
  const productJson = document.getElementById('product-json');
  let productData = null;
  if (productJson) {
    try { productData = JSON.parse(productJson.textContent); } catch(e) {}
  }

  function fmtMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  options.forEach(btn => {
    btn.addEventListener('click', () => {
      const position = btn.dataset.optionPosition;
      document.querySelectorAll(
        '[data-option-position="' + position + '"] .pdp-color-option, ' +
        '[data-option-position="' + position + '"] .pdp-size-option'
      ).forEach(o => {
        o.classList.remove('active');
        o.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-checked', 'true');

      if (colorName) colorName.textContent = btn.dataset.color || '';

      const variantId = btn.dataset.variantId;
      if (variantId && variantInput) variantInput.value = variantId;

      // Trigger wave with the swatch's own background color
      const swatchColor = btn.style.backgroundColor;
      if (swatchColor && btn.classList.contains('pdp-color-option')) {
        triggerWave(swatchColor);
      }

      // Update price + ATC button
      if (productData && variantId) {
        const variant = productData.variants.find(v => String(v.id) === String(variantId));
        if (variant) {
          const priceEl = document.querySelector('.pdp-price-current');
          const compareEl = document.querySelector('.pdp-price-compare');
          if (priceEl) priceEl.textContent = fmtMoney(variant.price);
          if (compareEl && variant.compare_at_price) {
            compareEl.textContent = fmtMoney(variant.compare_at_price);
          }
          if (stickyPriceEl) stickyPriceEl.textContent = fmtMoney(variant.price);
          if (cartBtn && !cartBtn.disabled) {
            const svg = cartBtn.querySelector('svg');
            const svgHtml = svg ? svg.outerHTML : '';
            const isPreorder = cartBtn.dataset.outletState === 'preorder';
            const label = isPreorder ? 'Pre-Order Now' : 'Add to Cart';
            cartBtn.innerHTML = svgHtml + ' ' + label + ' — ' + fmtMoney(variant.price);
          }
        }
      }

      // Swap main image if variant has one
      const variantImage = btn.dataset.variantImage;
      if (variantImage && mainImg) {
        swapMainImage(variantImage, btn.dataset.variantImageAlt || '');
        const matchingThumb = thumbs.find(t => {
          const img = t.querySelector('img');
          return img && img.getAttribute('data-full') === variantImage;
        });
        if (matchingThumb) setActiveThumb(matchingThumb);
      }
    });
  });

  // ─── Image Lightbox ───
  const lightbox = document.getElementById('pdp-lightbox');
  const zoomBtn = document.querySelector('.pdp-gallery-zoom-btn');
  if (lightbox && zoomBtn && mainImg) {
    const lbImg = lightbox.querySelector('.pdp-lightbox-img');
    const lbClose = lightbox.querySelector('.pdp-lightbox-close');
    const lbPrev = lightbox.querySelector('.pdp-lightbox-prev');
    const lbNext = lightbox.querySelector('.pdp-lightbox-next');

    function openLightbox() {
      lbImg.src = mainImg.src;
      lbImg.alt = mainImg.alt;
      lightbox.hidden = false;
      requestAnimationFrame(() => lightbox.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      lightbox.classList.remove('is-open');
      setTimeout(() => { lightbox.hidden = true; }, 250);
      document.body.style.overflow = '';
    }
    function step(delta) {
      if (!thumbs.length) return;
      const active = document.querySelector('.pdp-gallery-thumbs button.active');
      const idx = active ? thumbs.indexOf(active) : 0;
      const next = thumbs[(idx + delta + thumbs.length) % thumbs.length];
      next.click();
      const img = next.querySelector('img');
      if (img) {
        const src = img.getAttribute('data-full') || img.src;
        lbImg.src = src;
        lbImg.alt = img.alt || '';
      }
    }
    zoomBtn.addEventListener('click', openLightbox);
    lbClose.addEventListener('click', closeLightbox);
    lbImg.addEventListener('click', closeLightbox);
    if (lbPrev) lbPrev.addEventListener('click', () => step(-1));
    if (lbNext) lbNext.addEventListener('click', () => step(1));
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', (e) => {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowRight') step(1);
      else if (e.key === 'ArrowLeft') step(-1);
    });
  }

  // ─── Quantity Selector ───
  const qtyInput = document.getElementById('pdp-quantity-input');
  document.querySelectorAll('.pdp-quantity-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      const delta = parseInt(btn.dataset.qtyDelta, 10) || 0;
      const current = parseInt(qtyInput.value, 10) || 1;
      const next = Math.max(1, current + delta);
      qtyInput.value = next;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

})();
